import { Button } from 'antd';
import classNames from 'classnames';

import { ThreeDotsSpinner } from '../data/Spinner';
import { useButtonsStyles } from './buttons.styles';

export function DotButton({ active, className, ...rest }) {
  const { styles } = useButtonsStyles();

  return (
    <div
      {...rest}
      className={classNames(
        'DotButton',
        styles.dotButton,
        { active },
        className
      )}
    />
  );
}

export function CustomLoaderButton({ loading, children, ...rest }) {
  return (
    <Button loading={loading} {...rest}>
      {children}
      {loading && <ThreeDotsSpinner />}
    </Button>
  );
}
